import { SupportedCompaniesTypes } from './types';

export type MetaProps = 'title' | 'privacyLink' | 'termsLink';
export type MetaValue = Record<MetaProps, any>;
export type MetaObject = Record<SupportedCompaniesTypes, MetaValue>;

export const META: MetaObject = {
    gamebreaker: {
        title: 'GameBreaker',
        termsLink: '/terms-of-service',
        privacyLink: 'https://gamebreaker.com/privacy-policy',
    },

    apparel: {
        title: 'Wooter Apparel',
        termsLink: 'https://wooterapparel.com/return-policy',
        privacyLink: 'https://wooterapparel.com/return-policy',
    },
};
